import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

export const useLocation = createRouterSelector((state) => state.location);
